<template>
  <div class="savedDesignItem">
    <div class="savedDesignWrapper">
      <div class="actions">
        <div
          :disabled="design && design.artRequest && design.artRequest.isActive"
          class="delete"
          @click="askDeleteDesign(design)"
        >
          <div class="icon">
            <font-awesome-icon :icon="['far', 'trash-alt']" />
          </div>
          <div class="text">
            Delete
          </div>
        </div>
        <div class="divider" />
        <div class="duplicate">
          <div class="icon">
            <font-awesome-icon :icon="['far', 'clone']" rotation="90" />
          </div>
          <div class="text">
            Duplicate
          </div>
        </div>
      </div>
      <div
        class="labelTitle discontinued"
        v-if="
          !design.product.isPublished ||
            (design.pairProduct && !design.pairProduct.isPublished)
        "
      >
        Discontinued
      </div>
      <div class="labelTitle artRequest" v-else-if="design.artRequest">
        Art Request
      </div>
      <div class="tile" @click="goToCustomizer(design)">
        <div class="image">
          <div
            v-if="design.thumbnailSmallCenterPath"
            class="imageContainer"
            :style="{
              'background-image': `url('${design.thumbnailSmallCenterPath}')`
            }"
          >
            &nbsp;
          </div>
          <div v-else>
            No image
          </div>
        </div>
        <div class="info">
          <div class="firstLine">
            <div class="styleName">
              {{ design.style }}
            </div>
            <div class="date">
              {{ new Date(design.modifiedAt) | dateFormat('MM/DD/YY') }}
            </div>
          </div>
          <div class="designName">
            {{ design.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const userStore = namespace('userStore')

@Component({
  components: {}
})
export default class SavedDesign extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  design

  @userStore.Action('setOverrideValidationMinimum')
  actionSetOverrideValidationMinimum

  askDeleteDesign(design) {
    this.confirmAlert(
      'Are you sure you want to delete the design? ',
      'Yes',
      () => {
        this.$emit('delete-design', design)
      }
    )
  }

  goToCustomizer(design) {
    if (design.product.isPublished) {
      if (design.overrideValidationMinimum) {
        this.actionSetOverrideValidationMinimum(
          design.overrideValidationMinimum
        )
      }
      this.$router.push({
        name: 'designPreview',
        params: {
          id: design._id
        }
      })
    } else {
      this.errorMessage("This product's design has been discontinued")
    }
  }
}
</script>

<style lang="scss" scoped>
div [disabled] {
  pointer-events: none;
  opacity: 0.5;
}
.savedDesignItem {
  background: #ffffff;
  border: 1px solid #696969;
  margin: 8.5px;
  min-width: 330px;
  position: relative;

  .savedDesignWrapper {
    margin-top: -35px;
  }

  &:hover {
    background: #f5f6fe;
    border: none;
    .savedDesignWrapper {
      box-shadow: -1px 0 22px 0 rgba(0, 0, 0, 0.15);
    }
    .actions {
      opacity: 1;
    }
  }
}

.actions {
  align-items: center;
  background-color: white;
  border-bottom: 1px solid #a7a7a7;
  display: flex;
  opacity: 0;
  width: 100%;

  > div {
    align-items: center;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    justify-content: center;
    letter-spacing: 0.5px;
    padding: 10px 0 4px;
    text-transform: uppercase;
    width: 50%;
  }
  .icon {
    margin-right: 4px;
  }
  .text {
    color: #1324da;
  }
  .divider {
    background-color: #a7a7a7;
    height: 16px;
    width: 1px;
  }
}
#noData {
  text-align: center;
}
.discontinued {
  background-color: #fff1aa;
}
.artRequest {
  background-color: #a9e3ff;
}
.labelTitle {
  padding: 3px 4px 1px 9px;
  position: absolute;
  left: -1px;
  top: 14px;

  font-size: rem(12px);
  font-weight: bold;
  color: #202020;
  letter-spacing: 0.35px;
  line-height: 17px;
  text-align: center;
  text-transform: uppercase;
}
.tile {
  cursor: pointer;
  display: flex;
  .image {
    align-items: center;
    background-color: white;
    display: flex;
    height: 146px;
    justify-content: center;
    padding: 10px;
    width: 101px;
    .imageContainer {
      background-size: contain;
      background-position: center center;
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
    }
  }
  .info {
    flex: auto;
    font-size: rem(14px);
    padding: 13px 16px 22px 15px;
    .firstLine {
      display: flex;
      justify-content: space-between;
      letter-spacing: 0.41px;
      line-height: 19px;
      margin-bottom: 7px;
      text-transform: uppercase;
      .styleName {
        color: #202020;
        font-weight: bold;
        max-width: 138px;
      }
      .date {
        color: #000000;
      }
    }
    .designName {
      color: #202020;
      font-size: rem(13px);
      font-weight: 500;
      letter-spacing: 0.38px;
      line-height: 17px;
      max-width: 196px;
      text-transform: uppercase;
    }
  }
}
</style>
